// extracted by mini-css-extract-plugin
var _1 = "SharingDropdownAccessLevelSelect-module__animateUploadProgressBarWidth--gxGXx";
var _2 = "SharingDropdownAccessLevelSelect-module__animatedBackground--DAK7p";
var _3 = "SharingDropdownAccessLevelSelect-module__button--dHclI";
var _4 = "SharingDropdownAccessLevelSelect-module__tooltip--BBu46";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button", _4 as "tooltip" }
